module.exports = __webpack_public_path__ + "static/media/logo.07296e40.svg";